import { useState } from '@wordpress/element';
import styled from "styled-components";
import {Helper} from "./lib/dxf";
import SVGContainer from "./components/SVGContainer";
import DxfHeaderContainer from "./components/DxfHeaderContainer";
import DXFConfigurateur from "./components/DXF/DXFConfigurateur";
import Button from "./components/Button";
import {device, PHONE_NUMBER} from "./helper/constants";

const Wrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: 520px;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media ${device.tablet} {
      padding: 10%;
    }
    @media ${device.mobile} {
      padding: 0;
    }
  
    
`;

const DXFContainer = styled.div`
    width: 100%;
    margin-top: -40px;
    padding: 0 10px 10px 10px;

    &.md {
        margin-top: 0;
        padding: 0;
    }
`;

const DXFUploader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 10px 10px 10px;
    width: 100%;
    margin-top: -25px;
  
    & input {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    & input + label {
        font-size: 1.25em;
        font-weight: 700;
        color: white;
        background-color: #144344;
        cursor: pointer;
        height: 44px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50px;    
    }
    
    & input:focus + label,
    & input + label:hover {
        background-color: #144344;
    }
  
    & div.container {
        min-height: 225px;
        width: 100%;
        background-color: #fff;
        border-radius: 8px;
        border: 1px solid #EFEFEF;
        padding: 20px;
    }
    & div.empty-zone {
        background-color: #E4E4F4;
        border: 2px dashed #144344;
        min-height: 225px;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
    }

    & div.empty-zone img {
        width: 126px;
    }

    & div.empty-zone span {
        font-size: 21px;
        font-weight: bold;
        color: #144344;
        width: 80%;
        margin-top: 10px;
        text-align: center;
    }
`;

const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 30px;
    width: 100%;
    justify-content: center;
`;

const ErrorSVGContainer = styled.div`
  margin: 30px 0;

  & span {
    color: #d34343;
  }

  & a {
    color: #144344;
  }
`;
const AppDxfForm = ({mode}) => {
    const [svgFile, setSvgFile] = useState(null);
    const [widthSvg, setWidthSvg] = useState(null);
    const [heightSvg, setHeightSvg] = useState(null);
    const [configStarted, setConfigStarted] = useState(false);
    const [errorSvg, setErrorSvg] = useState(null);
    const [dxfFile, setDxfFile] = useState(null);
    const readFile = (e) => {
        const reader = new FileReader();

        reader.onload = async (e) => {
            const dxfContents = (e.target.result);
            setDxfFile(dxfContents);
            const helper = new Helper(dxfContents);
            const svgContent = helper.toSVG();
            setSvgFile(svgContent);

            const svgElement = document.getElementById(`hjt-svg${mode ? '-modal' : ''}`);
            const {width, height} = svgElement.viewBox.baseVal;

            if (width) {
                setWidthSvg(width);
            }
            if (height) {
                setHeightSvg(height);
            }

            if (!width && !height || width === 0 || height === 0) {
                setErrorSvg(true);
            }

        };
        reader.onerror = async (e) => {
            setErrorSvg(true);
        }
        reader.onabort = async (e) => {
            console.log("read file abort");
            setErrorSvg(true);
        }
        reader.readAsBinaryString(e.target.files[0]);
    }

    const openDxfConfigurateur = () => {
        setConfigStarted(true);
    }

    const cancel = () => {
        setSvgFile(null);
        setWidthSvg(null);
        setHeightSvg(null);
    }


    return (
        <Wrapper>
            <DxfHeaderContainer mode={mode} configStarted={configStarted} />

            { configStarted ? (
                <DXFContainer className={mode ? 'md' : ''}>
                    <DXFConfigurateur
                        svg={svgFile}
                        widthSVG={widthSvg}
                        heightSVG={heightSvg}
                        dxfContent={dxfFile}
                        mode={mode}
                    />
                </DXFContainer>
            ) : (
                <DXFUploader>
                    <div className="container">
                        {svgFile ? (
                            <SVGContainer
                                src={svgFile}
                                width={widthSvg}
                                height={heightSvg}
                                mode={mode}
                            />
                        ): (
                            <div className="empty-zone">
                                <img src={"/wp-content/uploads/2023/09/icon-dxf.png"} alt={"Télécharger votre DXF"} />
                                <span>Envoyer mon fichier DXF à découper</span>
                            </div>
                        )}
                        {(svgFile && !errorSvg)  ? (
                            <ButtonsContainer>
                                <Button
                                    handleClick={cancel}
                                >
                                    Annuler
                                </Button>
                                <Button
                                    handleClick={openDxfConfigurateur}
                                    icon={"/wp-content/uploads/2021/09/icon-customize.svg"}
                                    iconPosition={"left"}
                                    disabled={false}
                                    variation={"btn-green"}
                                >
                                    Personnaliser
                                </Button>
                            </ButtonsContainer>
                        ) : (
                            <>
                                {errorSvg && (
                                  <ErrorSVGContainer>
                                    <span>Votre fichier DXF ne contient pas suffisamment d'information pour la découpe.
                                        <a href={`tel:${PHONE_NUMBER}`} > Appelez nous</a> pour résoudre le problème.
                                    </span>
                                  </ErrorSVGContainer>
                                )}
                                <input type="file"  accept=".dxf" name="file" id="file" onChange={(e) => readFile(e)} />
                                <label htmlFor="file"><strong>Importer mon fichier DXF</strong></label>
                            </>
                        )}

                    </div>
                </DXFUploader>
            )}
        </Wrapper>
    );
};
export default AppDxfForm;
